import clone from 'lodash/clone'

const selectPath = (paths: any) => {
    let path = paths.reduce(function (selectedPath: any, path: any) {
        if (selectedPath === null) {
            return path
        } else {
            if (path.unk < selectedPath.unk)
                return path;
            if (path.unk === selectedPath.unk) {
                if (path.mw < selectedPath.mw)
                    return path
                if (path.mw === selectedPath.mw) {
                    if (path.w < selectedPath.w)
                        return path
                }
            }
            return selectedPath
        }
    }, null)

    return path
}

const createPath = () => {
    return [{ p: null, w: 0, unk: 0, type: "INIT", mw: 0 }]
}

export const pathSelector = {
    selectPath,
    createPath
}

export const PathSelector = () => {
    return clone(pathSelector)
}